import { render, staticRenderFns } from "./CardGroups.vue?vue&type=template&id=5879b27f&scoped=true&"
import script from "./CardGroups.vue?vue&type=script&lang=js&"
export * from "./CardGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879b27f",
  null
  
)

export default component.exports